var map = {
	"./Actions.js": 8,
	"./Constants.js": 26,
	"./calcs/2018/calculator_node.js": 840,
	"./calcs/2018/categories.js": 267,
	"./calcs/2018/data-structures/Budget Model (orig) - Budget Projections.js": 841,
	"./calcs/2018/data-structures/Budget Model (orig) - Initial Budget Projections.js": 842,
	"./calcs/2018/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 843,
	"./calcs/2018/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 844,
	"./calcs/2018/data-structures/Economic Model (orig) - CBO Assumed.js": 563,
	"./calcs/2018/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 845,
	"./calcs/2018/data-structures/Weighted Interest On Debt.js": 846,
	"./calcs/2018/data-structures/bc_hc components calc (orig).js": 847,
	"./calcs/2018/data-structures/bc_oasdhi rev model (orig).js": 848,
	"./calcs/2018/data-structures/bc_other mandatory (orig).js": 849,
	"./calcs/2018/data-structures/bc_ss outlay model (orig).js": 850,
	"./calcs/2018/data-structures/cbo_10_year.js": 561,
	"./calcs/2018/data-structures/cbo_lt_budget.js": 851,
	"./calcs/2018/data-structures/cbo_lt_econ.js": 562,
	"./calcs/2018/growthOptions.js": 564,
	"./calcs/2018/growthSettings.js": 852,
	"./calcs/2018/prepare.js": 853,
	"./calcs/2018/sheets.js": 520,
	"./calcs/2018/technicalAssumptions.js": 355,
	"./calcs/2019_01/categories.js": 268,
	"./calcs/2019_01/data-structures/Budget Model (orig) - Budget Projections.js": 857,
	"./calcs/2019_01/data-structures/Budget Model (orig) - Initial Budget Projections.js": 858,
	"./calcs/2019_01/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 859,
	"./calcs/2019_01/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 860,
	"./calcs/2019_01/data-structures/Economic Model (orig) - CBO Assumed.js": 861,
	"./calcs/2019_01/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 862,
	"./calcs/2019_01/data-structures/Weighted Interest On Debt.js": 863,
	"./calcs/2019_01/data-structures/bc_hc components calc (orig).js": 864,
	"./calcs/2019_01/data-structures/bc_oasdhi rev model (orig).js": 865,
	"./calcs/2019_01/data-structures/bc_other mandatory (orig).js": 866,
	"./calcs/2019_01/data-structures/bc_ss outlay model (orig).js": 867,
	"./calcs/2019_01/data-structures/cbo_10_year.js": 868,
	"./calcs/2019_01/data-structures/cbo_lt_budget.js": 869,
	"./calcs/2019_01/data-structures/cbo_lt_econ.js": 870,
	"./calcs/2019_01/growthOptions.js": 565,
	"./calcs/2019_01/growthSettings.js": 871,
	"./calcs/2019_01/prepare.js": 872,
	"./calcs/2019_01/sheets.js": 521,
	"./calcs/2019_01/technicalAssumptions.js": 566,
	"./calcs/2019_06/categories.js": 269,
	"./calcs/2019_06/data-structures/Budget Model (orig) - Budget Projections.js": 873,
	"./calcs/2019_06/data-structures/Budget Model (orig) - Initial Budget Projections.js": 874,
	"./calcs/2019_06/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 875,
	"./calcs/2019_06/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 876,
	"./calcs/2019_06/data-structures/Economic Model (orig) - CBO Assumed.js": 877,
	"./calcs/2019_06/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 878,
	"./calcs/2019_06/data-structures/Weighted Interest On Debt.js": 879,
	"./calcs/2019_06/data-structures/bc_hc components calc (orig).js": 880,
	"./calcs/2019_06/data-structures/bc_oasdhi rev model (orig).js": 881,
	"./calcs/2019_06/data-structures/bc_other mandatory (orig).js": 882,
	"./calcs/2019_06/data-structures/bc_ss outlay model (orig).js": 883,
	"./calcs/2019_06/data-structures/cbo_10_year.js": 884,
	"./calcs/2019_06/data-structures/cbo_lt_budget.js": 885,
	"./calcs/2019_06/data-structures/cbo_lt_econ.js": 886,
	"./calcs/2019_06/growthOptions.js": 567,
	"./calcs/2019_06/growthSettings.js": 887,
	"./calcs/2019_06/prepare.js": 888,
	"./calcs/2019_06/sheets.js": 522,
	"./calcs/2019_06/technicalAssumptions.js": 568,
	"./calcs/2019_08/categories.js": 270,
	"./calcs/2019_08/data-structures/Budget Model (orig) - Budget Projections.js": 889,
	"./calcs/2019_08/data-structures/Budget Model (orig) - Initial Budget Projections.js": 890,
	"./calcs/2019_08/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 891,
	"./calcs/2019_08/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 892,
	"./calcs/2019_08/data-structures/Economic Model (orig) - CBO Assumed.js": 893,
	"./calcs/2019_08/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 894,
	"./calcs/2019_08/data-structures/Weighted Interest On Debt.js": 895,
	"./calcs/2019_08/data-structures/bc_hc components calc (orig).js": 896,
	"./calcs/2019_08/data-structures/bc_oasdhi rev model (orig).js": 897,
	"./calcs/2019_08/data-structures/bc_other mandatory (orig).js": 898,
	"./calcs/2019_08/data-structures/bc_ss outlay model (orig).js": 899,
	"./calcs/2019_08/data-structures/cbo_10_year.js": 900,
	"./calcs/2019_08/data-structures/cbo_lt_budget.js": 901,
	"./calcs/2019_08/data-structures/cbo_lt_econ.js": 902,
	"./calcs/2019_08/growthOptions.js": 569,
	"./calcs/2019_08/growthSettings.js": 903,
	"./calcs/2019_08/prepare.js": 904,
	"./calcs/2019_08/sheets.js": 523,
	"./calcs/2019_08/technicalAssumptions.js": 570,
	"./calcs/2019_08_tax/categories.js": 271,
	"./calcs/2019_08_tax/data-structures/Budget Model (orig) - Budget Projections.js": 905,
	"./calcs/2019_08_tax/data-structures/Budget Model (orig) - Initial Budget Projections.js": 906,
	"./calcs/2019_08_tax/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 907,
	"./calcs/2019_08_tax/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 908,
	"./calcs/2019_08_tax/data-structures/Economic Model (orig) - CBO Assumed.js": 909,
	"./calcs/2019_08_tax/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 910,
	"./calcs/2019_08_tax/data-structures/Weighted Interest On Debt.js": 911,
	"./calcs/2019_08_tax/data-structures/bc_hc components calc (orig).js": 912,
	"./calcs/2019_08_tax/data-structures/bc_oasdhi rev model (orig).js": 913,
	"./calcs/2019_08_tax/data-structures/bc_other mandatory (orig).js": 914,
	"./calcs/2019_08_tax/data-structures/bc_ss outlay model (orig).js": 915,
	"./calcs/2019_08_tax/data-structures/cbo_10_year.js": 916,
	"./calcs/2019_08_tax/data-structures/cbo_lt_budget.js": 917,
	"./calcs/2019_08_tax/data-structures/cbo_lt_econ.js": 918,
	"./calcs/2019_08_tax/data-structures/tc_baseline.js": 919,
	"./calcs/2019_08_tax/data-structures/tc_change_growthrates.js": 920,
	"./calcs/2019_08_tax/data-structures/tc_change_options.js": 921,
	"./calcs/2019_08_tax/growthOptions.js": 571,
	"./calcs/2019_08_tax/growthSettings.js": 922,
	"./calcs/2019_08_tax/prepare.js": 923,
	"./calcs/2019_08_tax/sheets.js": 524,
	"./calcs/2019_08_tax/technicalAssumptions.js": 572,
	"./calcs/2020_01/categories.js": 272,
	"./calcs/2020_01/data-structures/Budget Model (orig) - Budget Projections.js": 924,
	"./calcs/2020_01/data-structures/Budget Model (orig) - Initial Budget Projections.js": 925,
	"./calcs/2020_01/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 926,
	"./calcs/2020_01/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 927,
	"./calcs/2020_01/data-structures/Economic Model (orig) - CBO Assumed.js": 928,
	"./calcs/2020_01/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 929,
	"./calcs/2020_01/data-structures/Weighted Interest On Debt.js": 930,
	"./calcs/2020_01/data-structures/bc_hc components calc (orig).js": 931,
	"./calcs/2020_01/data-structures/bc_oasdhi rev model (orig).js": 932,
	"./calcs/2020_01/data-structures/bc_other mandatory (orig).js": 933,
	"./calcs/2020_01/data-structures/bc_ss outlay model (orig).js": 934,
	"./calcs/2020_01/data-structures/cbo_10_year.js": 935,
	"./calcs/2020_01/data-structures/cbo_lt_budget.js": 936,
	"./calcs/2020_01/data-structures/cbo_lt_econ.js": 937,
	"./calcs/2020_01/growthOptions.js": 573,
	"./calcs/2020_01/growthSettings.js": 938,
	"./calcs/2020_01/prepare.js": 939,
	"./calcs/2020_01/sheets.js": 525,
	"./calcs/2020_01/technicalAssumptions.js": 574,
	"./camelCase.js": 214,
	"./categoryFunctions.js": 19,
	"./categorymeta.js": 218,
	"./colors.js": 191,
	"./components/Account.js": 404,
	"./components/ActionBar.js": 220,
	"./components/AddFeaturedCalc.js": 407,
	"./components/Admin.js": 408,
	"./components/AnimatedPath.js": 245,
	"./components/AnimatedRect.js": 71,
	"./components/App.js": 586,
	"./components/ArticleListItem.js": 464,
	"./components/Authenticate.js": 458,
	"./components/Authors.js": 1151,
	"./components/Budget.js": 436,
	"./components/BudgetChange.js": 468,
	"./components/BudgetChanges.js": 469,
	"./components/BudgetCircle.js": 1152,
	"./components/BudgetGrowthRateSelect.js": 442,
	"./components/BudgetMeta.js": 1153,
	"./components/BudgetSnapshot.js": 233,
	"./components/CalculatorTile.js": 461,
	"./components/Calculators.js": 405,
	"./components/Category.js": 440,
	"./components/CategoryDetail.js": 446,
	"./components/CategoryHeader.js": 92,
	"./components/CategorySnapshot.js": 65,
	"./components/CategoryTrail.js": 235,
	"./components/CategoryValueInYear.js": 1154,
	"./components/Counter.js": 97,
	"./components/DefaultEdit.js": 1155,
	"./components/DisplayYearSelect.js": 1170,
	"./components/DisplayYearSlider.js": 234,
	"./components/DoneEditing.js": 448,
	"./components/Econ.js": 444,
	"./components/EconGrowthRateSelect.js": 445,
	"./components/EconTrend.js": 470,
	"./components/EconTrendChart.js": 185,
	"./components/Edit.js": 435,
	"./components/EditBudgetActionBar.js": 1171,
	"./components/EditBudgetMeta.js": 456,
	"./components/EditBudgetMetaModal.js": 455,
	"./components/EditForm.js": 457,
	"./components/EditMetaButton.js": 1172,
	"./components/Email.js": 421,
	"./components/Facebook.js": 419,
	"./components/FeaturedArticles.js": 463,
	"./components/FeaturedCalcsAdmin.js": 409,
	"./components/FeaturedCalculators.js": 460,
	"./components/FullCarousel.js": 1173,
	"./components/Group.js": 246,
	"./components/GrowthRatePercentageInput.js": 152,
	"./components/GrowthRateSelect.js": 236,
	"./components/GrowthRateSettings.js": 441,
	"./components/GrowthSlider.js": 443,
	"./components/HamburgerMenu.js": 433,
	"./components/HeroChart/Choices.js": 412,
	"./components/HeroChart/HoverTargets.js": 222,
	"./components/HeroChart/Legend.js": 439,
	"./components/HeroChart/XAxis.js": 223,
	"./components/HeroChart/YAxis.js": 224,
	"./components/HeroChart/chart-button-controls.js": 227,
	"./components/HeroChart/chart-datum.js": 148,
	"./components/HeroChart/chart-dropdown-controls.js": 226,
	"./components/HeroChart/chart.js": 225,
	"./components/HeroChart/index.js": 52,
	"./components/HeroChart/super-hero-chart.js": 221,
	"./components/HeroChart/tooltips.js": 438,
	"./components/Home.js": 459,
	"./components/Image.js": 465,
	"./components/Lightswitch.js": 1174,
	"./components/LinkedIn.js": 422,
	"./components/Loading.js": 150,
	"./components/Login.js": 430,
	"./components/Nav.js": 308,
	"./components/NewBudgetActionBar.js": 1175,
	"./components/Policy.js": 237,
	"./components/PolicyList.js": 447,
	"./components/PolicyRecap.js": 1176,
	"./components/Profile.js": 406,
	"./components/Projections.js": 437,
	"./components/QuickChange.js": 449,
	"./components/QuickChanges.js": 239,
	"./components/RadioGroup.js": 1177,
	"./components/ResetButton.js": 1178,
	"./components/ResetCalcButton.js": 1179,
	"./components/RoundButton.js": 1180,
	"./components/SaveButton.js": 451,
	"./components/ScrollToTopOnMount.js": 103,
	"./components/SegmentedBar.js": 1181,
	"./components/ShareModal.js": 228,
	"./components/SlideToggleButton.js": 149,
	"./components/SpendingVsRevenue.js": 471,
	"./components/StickyTop.js": 1182,
	"./components/Styleguide.js": 466,
	"./components/Tables.js": 467,
	"./components/TreeMap.js": 1183,
	"./components/Tutorial.js": 232,
	"./components/Twitter.js": 420,
	"./components/UserChanges.js": 238,
	"./components/VideoModal.js": 229,
	"./components/ViewBudget.js": 1184,
	"./components/accordion/accordion.js": 369,
	"./components/accordion/index.js": 418,
	"./components/embed/Embed.js": 390,
	"./components/embed/app/app.js": 391,
	"./components/embed/app/directory.js": 474,
	"./components/embed/app/index.js": 626,
	"./components/embed/app/instance.js": 310,
	"./components/embed/changeTypes.js": 106,
	"./components/embed/changes/changes.js": 395,
	"./components/embed/changes/index.js": 1189,
	"./components/embed/demoData.js": 1190,
	"./components/embed/entry-point/entry-point.js": 393,
	"./components/embed/entry-point/index.js": 476,
	"./components/embed/final/final.js": 392,
	"./components/embed/final/index.js": 475,
	"./components/embed/index.js": 481,
	"./components/embed/questions/index.js": 477,
	"./components/embed/questions/progress.js": 478,
	"./components/embed/questions/question.js": 480,
	"./components/embed/questions/questions.js": 394,
	"./components/embed/questions/status.js": 479,
	"./components/icons/AccountIcon.js": 431,
	"./components/icons/AmericaOffBalanceIcon.js": 79,
	"./components/icons/CalculatorIcon.js": 104,
	"./components/icons/Changes.js": 453,
	"./components/icons/CheckIcon.js": 1191,
	"./components/icons/Close.js": 72,
	"./components/icons/CtaArrow.js": 472,
	"./components/icons/Dashboard.js": 454,
	"./components/icons/DeleteIcon.js": 147,
	"./components/icons/DescribeIcon.js": 240,
	"./components/icons/Down.js": 462,
	"./components/icons/DownloadIcon.js": 230,
	"./components/icons/EconSettingsIcon.js": 1192,
	"./components/icons/EditIcon.js": 146,
	"./components/icons/Gear.js": 1193,
	"./components/icons/HamburgerIcon.js": 432,
	"./components/icons/InfoIcon.js": 434,
	"./components/icons/ResetCircleIcon.js": 450,
	"./components/icons/ResetIcon.js": 473,
	"./components/icons/Save.js": 452,
	"./components/icons/SelectCaret.js": 102,
	"./components/icons/ShareIcon.js": 231,
	"./components/icons/Twitter.js": 1194,
	"./components/icons/ViewIcon.js": 219,
	"./components/icons/slide_toggle_arrow.js": 417,
	"./components/next-arrow-icon.js": 151,
	"./components/report/budget-changes.js": 414,
	"./components/report/calc-header.js": 425,
	"./components/report/category-changes.js": 415,
	"./components/report/controls.js": 426,
	"./components/report/footer.js": 427,
	"./components/report/index.js": 410,
	"./components/report/policy.js": 416,
	"./components/report/projections.js": 411,
	"./components/report/report-header.js": 424,
	"./components/report/report.js": 367,
	"./components/tax-calc/chart.js": 429,
	"./components/tax-calc/index.js": 428,
	"./components/tax-calc/tax-calc.js": 385,
	"./configureStore.js": 401,
	"./definitions.js": 12,
	"./difference.js": 49,
	"./downloadVariables.js": 396,
	"./fb.js": 40,
	"./formatDollars.js": 5,
	"./formulas.js": 21,
	"./hooks/useBreakpoint.js": 413,
	"./hooks/useFetch.js": 241,
	"./hooks/useMeasure.js": 1195,
	"./index.js": 490,
	"./localStorage.js": 311,
	"./normalize.js": 18,
	"./operations.js": 11,
	"./processors.js": 333,
	"./reducers/calculator.js": 402,
	"./reducers/helpers.js": 131,
	"./reducers/session.js": 482,
	"./reducers/setCategoriesToDefault.js": 403,
	"./registerServiceWorker.js": 1197,
	"./renderCalc.js": 242,
	"./rounding.js": 95,
	"./versions.js": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;